/* eslint-disable prettier/prettier */
import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store";
import Home from "@/views/Home.vue";
import DocumentValidate from "@/views/Home/DocumentValidate";
import ExternalSignature from "@/views/Home/ExternalSignature";
import CancelInscription from "@/views/Home/CancelInscription";
import ProcessView from "@/views/Process/ProcessView";
import ConsultSearch from "@/views/Home/ConsultSearch";
import ConsultSearchDetail from "@/views/Home/ConsultSearchDetail";
import ConsultViprocDetail from "@/views/Home/ConsultViprocDetail";
import ReferencePage from "@/views/Home/Reference";
import DigitalGOVPage from "@/views/Home/DigitalGOV";
import SystemDOCPage from "@/views/Home/SystemDOC";
import DoeModelEditor from "@/views/App/DoeModelEditor";
import DoeModelView from "@/views/App/DoeModelView";

import PageNotFound from "@/views/PageNotFound.vue";
import { App, General } from "@/utils/constants";
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";

import { ToastProgrammatic as Toast } from "buefy";

Vue.use(VueRouter);

const AppHome = () =>
  import(/* webpackChunkName: "app-home" */ "../views/AppHome.vue");
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "../views/App/Dashboard.vue");
const AdmCard = () =>
  import(/* webpackChunkName: "admin" */ "../views/App/AdmCard.vue");
const Users = () =>
  import(/* webpackChunkName: "users" */ "../views/App/Users.vue");
const User = () =>
  import(/* webpackChunkName: "user" */ "../views/App/User.vue");
const UserConfigs = () =>
  import(
    /* webpackChunkName: "configuracoes-usuario" */ "../views/App/UserConfigs.vue"
  );
const Bookmarks = () =>
  import(
    /* webpackChunkName: "bookmarks" */ "../views/App/Bookmarks.vue"
  );
const CreateBookmark = () =>
  import(
    /* webpackChunkName: "criar-marcador" */ "../views/App/CreateBookmark.vue"
  );
const PartAddress = () =>
  import(
    /* webpackChunkName: "cadastro-orgao" */ "../views/App/PartAddress.vue"
  );
const Category = () =>
  import(/* webpackChunkName: "category" */ "../views/App/Category.vue");
const Subcategory = () =>
  import(/* webpackChunkName: "subcategory" */ "../views/App/Subcategory.vue");
const Subcategory2 = () =>
  import(
    /* webpackChunkName: "subcategory2" */ "../views/App/Subcategory2.vue"
  );
const ProcessForm = () =>
  import(/* webpackChunkName: "processo" */ "../views/App/ProcessForm.vue");
const DOEPanel = () =>
  import(/* webpackChunkName: "doe" */ "../views/App/DOEPanel.vue");
const ProcessPainel = () =>
  import(
    /* webpackChunkName: "processos" */ "../views/App/ProcessPainel.vue"
  );
const SignaturePanel = () =>
  import(
    /* webpackChunkName: "painel-signature" */ "../views/App/SignaturePanel.vue"
  );
const ProcessDetails = () =>
  import(
    /* webpackChunkName: "detalhamento-processos" */ "../views/App/ProcessDetails.vue"
  );
const DocumentDetails = () =>
  import(
    /* webpackChunkName: "documento-details" */ "../views/App/DocumentDetailsView.vue"
  );
const DocumentEditor = () =>
  import(
    /* webpackChunkName: "documento-editor" */ "../views/App/DocumentEditor"
  );
const SearchProcess = () =>
  import(/* webpackChunkName: "busca" */ "../views/App/SearchProcess");
const Models = () =>
  import(/* webpackChunkName: "modelos" */ "../views/App/Models");
const ModelEditor = () =>
  import(/* webpackChunkName: "model-editor" */ "../views/App/ModelEditor");
const PartGeneralInfo = () =>
  import(
    /* webpackChunkName: "orgao-infos-gerais" */ "../views/App/PartGeneralInfo"
  );
const Profiles = () =>
  import(/* webpackChunkName: "perfis" */ "../views/App/Profiles");
  const ProfileEditor = () =>
  import(/* webpackChunkName: "perfis-editor" */ "../views/App/ProfileEditor");
const SubjectsCategories = () =>
  import(
    /* webpackChunkName: "assuntos-categorias" */ "../views/App/SubjectsCategories"
  );
const ManageUnity = () =>
  import(
    /* webpackChunkName: "gestao-unidades" */ "../views/App/ManageUnity"
  );
const FeedbackPage = () =>
  import(/* webpackChunkName: "feedback-page" */ "../views/App/FeedbackPage");
const DOEModels = () =>
  import(/* webpackChunkName: "modelos-doe" */ "../views/App/DoeModels");
const Migrations = () =>
  import(/* webpackChunkName: "migrations" */ "../views/App/Migrations");
const ProcessMigration = () =>
  import(/* webpackChunkName: "process-migration" */ "../views/App/ProcessMigration");
const Versions = () =>
  import(/* webpackChunkName: "versions" */ "../views/Home/Versions");
const Permission = () =>
  import(/* webpackChunkName: "permission" */ "../views/App/Permission");
const PermissionList = () =>
  import(/* webpackChunkName: "permission-list" */ "../views/App/PermissionList");
const ProfileManagement = () =>
  import(/* webpackChunkName: "profile-management" */ "../views/App/ProfileManagement");
const Reports = () =>
  import(/* webpackChunkName: "permission-list" */ "../views/App/Reports");
const MessagesArea = () =>
  import(/* webpackChunkName: "permission-list" */ "../views/App/MessagesArea");
const SendMessage = () =>
  import(/* webpackChunkName: "permission-list" */ "../views/App/SendMessage");

const ifAuthenticated = (to, from, next) => {
  const token = localStorage.getItem("token") || null;
  if (token) {
    store.commit("setBreadcrumbs", { name: to.name, path: to.path });
    return next();
  } else if (to.path.match(/documento\/\w+/))
    localStorage.setItem("goDoc", to.path);

  next("/");
  store.dispatch("authLogout");
};

const ifAuthorized = (to, from, next, permission) => {
  if (store.getters.hasPermission(userPermissions[permission])) {
    return ifAuthenticated(to, from, next);
  }
  return next(from);
};

const haveSpecificPermissions = (to, from, next, permissions, checkOtherValidations = false) => {
  if (
    permissions
      .map(permission =>
        store.getters.hasPermission(userPermissions[permission])
      )
      .includes(true) || checkOtherValidations
  )
    return ifAuthenticated(to, from, next);
  else {
    Toast.open({
      message: `${General.YOU_DONT_HAVE_THIS_PERMISSION}.`,
      type: "is-danger",
      duration: 8000
    });
    return next(from);
  }
};

const haveProcessFileSign = async (to, from, next) => {
  const dispatchId = to.query.dispatchId;
  const processId = to.params.id;

  await store.dispatch("processFilesFilteredRequest", {
    is_primary: true,
    processId,
    dispatch_id: dispatchId
  });

  const getSignatureHistory = (id, getFile) =>
    store.getters[getFile](id)?.sign_history.some(
      history => 
        history.user_id !== store.getters.getCurrentUser.id &&
        history.status.includes("SIGNED") &&
        !history.only_historical
    );

  const hasSignatureInitialFile = dispatchId
    ? getSignatureHistory(dispatchId, 'getDispatchInitialFile')
    : getSignatureHistory(processId, 'getProcessInitialFile');
  
  if (hasSignatureInitialFile) return next(from);
  return ifAuthenticated(to, from, next);
}

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    redirect: "/"
  },
  {
    path: "/processo/:id",
    name: "Processo",
    component: ProcessView,
    props: route => ({ processId: route.params.id }),
  },
  {
    path: "/consultar-processo",
    name: "processConsult",
    props: route => ({
      nup: route.query.nup,
      showSingle: Boolean(route.query.showSingle)
    }),
    component: ConsultSearch
  },
  {
    path: "/consultar-processo/:nup",
    name: "processConsultDetail",
    props: route => ({
      nup: route.params.nup
    }),
    component: ConsultSearchDetail
  },
  {
    path: "/consultar-viproc",
    name: "viprocConsult",
    component: ConsultViprocDetail
  },
  {
    path: "/leis-referencias",
    name: "referencePage",
    component: ReferencePage
  },
  {
    path: "/leis-referencias-gov",
    name: "referenceGovPage",
    component: DigitalGOVPage
  },
  {
    path: "/documentacao",
    name: "docSystem",
    component: SystemDOCPage
  },
  {
    path: "/validar-documento",
    name: "documentValidate",
    props: route => ({
      hash: route.query.hash
    }),
    component: DocumentValidate
  },
  {
    path: "/versoes",
    name: App.Version.VERSIONS,
    component: Versions
  },
  {
    path: "/assinatura-externa/:id",
    name: "externalSignature",
    props: route => ({ solicitationId: route.params.id }),
    component: ExternalSignature
  },
  {
    path: "/cancelar-inscricao",
    name: "cancelInscription",
    props: route => ({
      hash: route.query.hash,
      notificationName: route.query.notification
    }),
    component: CancelInscription
  },
  {
    path: "/app",
    component: AppHome,
    beforeEnter: ifAuthenticated,
    meta: {
      breadcrumb: [{ name: App.Breadcrumb.START }]
    },

    children: [
      {
        path: "",
        redirect: "processos"
      },
      {
        path: "painel",
        name: "Painel",
        component: Dashboard,
        beforeEnter: ifAuthenticated,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START_AREA, link: App.Breadcrumb.APP_LINK },
            { name: App.Breadcrumb.DASHBOARD }
          ]
        }
      },
      {
        path: "admin",
        name: "Administração",
        component: AdmCard,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "ADM_VIEW"),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            { name: General.ADMINISTRATION }
          ]
        }
      },
      {
        path: "busca",
        name: "Busca",
        props: route => ({
          search: route.query.search
        }),
        component: SearchProcess,
        beforeEnter: ifAuthenticated,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            { name: "Busca" }
          ]
        }
      },
      {
        path: "admin/permissoes-perfis",
        name: "Gestão de permissões por Perfis",
        component: ProfileManagement,
        beforeEnter: (to, from, next) =>
        haveSpecificPermissions(to, from, next, [
          "MANAGE_PROFILES"
        ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            {
              name: General.PROFILES,
              link: "/app/admin/perfis"
            }
          ]
        }
      },
      {
        path: "admin/gestao-unidades",
        name: "Gestão de unidades",
        props: route => ({
          search: route.query.search
        }),
        component: ManageUnity,
        beforeEnter: (to, from, next) =>
        ifAuthorized(to, from, next, "MANAGE_UNITY"),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            { name: "gestão unidades" }
          ]
        }
      },
      {
        path: "admin/busca-usuario",
        name: "Usuários",
        component: Users,
        props: route => ({
          keepList: route.query.keepList
        }),
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_USER_ADM",
            "MANAGE_USER_PART",
            "MANAGE_USER_UNIT"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            { name: General.USERS }
          ]
        }
      },
      {
        path: "admin/usuario/:id",
        name: "Editar usuário",
        component: User,
        props: route => ({ userId: route.params.id }),
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_USER_ADM",
            "MANAGE_USER_PART",
            "MANAGE_USER_UNIT"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            { name: General.USERS, link: "/app/user" },
            { name: General.EDIT_USER }
          ]
        }
      },
      {
        path: "configuracoes-usuario",
        name: "Configurações do Usuário",
        component: UserConfigs,
        props: route => ({
          activeTab: route.query.activeTab
        }),
        beforeEnter: ifAuthenticated,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            { name: General.USERS }
          ]
        }
      },
      {
        path: "admin/marcadores",
        name: "Marcadores",
        component: Bookmarks,
        props: {
          isAdmBookmark: true,
        },
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_BOOKMARKS_ADM",
            "MANAGE_BOOKMARKS_PART",
            "MANAGE_BOOKMARKS_CAPACITY"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            { name: General.NOTIFICATIONS }
          ]
        }
      },
      {
        path: "criar-marcador",
        name: "Criar Marcador",
        component: CreateBookmark,
        props: route => ({
          isAdmBookmark: String(route.query.isAdmBookmark).toLowerCase() === "true"
        }),
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_BOOKMARKS_ADM",
            "MANAGE_BOOKMARKS_PART",
            "MANAGE_BOOKMARKS_CAPACITY"
          ], String(to.query.isAdmBookmark).toLowerCase() !== "true"),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            { name: General.NOTIFICATIONS }
          ]
        }
      },
      {
        path: "criar-marcador/:id",
        name: "Editar Marcador",
        component: CreateBookmark,
        props: route => ({
          id: route.params.id,
          isAdmBookmark: String(route.query.isAdmBookmark).toLowerCase() === "true"
        }),
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_BOOKMARKS_ADM",
            "MANAGE_BOOKMARKS_PART",
            "MANAGE_BOOKMARKS_CAPACITY"
          ], String(to.query.isAdmBookmark).toLowerCase() !== "true"),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: App.Breadcrumb.APP_ADMIN_LINK
            },
            { name: General.NOTIFICATIONS }
          ]
        }
      },
      {
        path: "novo-processo",
        name: "Novo Processo",
        component: ProcessForm,
        beforeEnter: ifAuthenticated,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            { name: General.NEW_PROCESS }
          ]
        }
      },
      {
        path: "processos",
        name: "Processos",
        component: ProcessPainel,
        beforeEnter: ifAuthenticated,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            { name: General.PROCESS_PAINEL }
          ]
        }
      },
      {
        path: App.MenuMain.SIGNATURES.toLowerCase(),
        name: App.MenuMain.SIGNATURES,
        component: SignaturePanel,
        beforeEnter: ifAuthenticated,
        meta: {
          breadcrumb: [
            { name: App.MenuMain.SIGNATURES }
          ]
        }
      },
      {
        path: "admin/permissoes",
        name: General.PERMISSIONS,
        component: PermissionList,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_PERMISSIONS"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.PROCESS_PAINEL,
              link: App.Breadcrumb.APP_PROCESS_PAINEL_LINK
            },
            {
              name: General.EDIT_PERMISSION,
              link: App.Breadcrumb.PERMISSIONS_LINK
            }
          ]
        }
      },
      {
        path: "admin/permissao/:id",
        name: General.EDIT_PERMISSION,
        component: Permission,
        props: route => ({
          permissionId: route.params.id
        }),
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_PERMISSIONS"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.PROCESS_PAINEL,
              link: App.Breadcrumb.APP_PROCESS_PAINEL_LINK
            },
            { name: General.PERMISSIONS }
          ]
        }
      },
      {
        path: "processos/detalhamento/:id",
        name: "Detalhamento",
        component: ProcessDetails,
        beforeEnter: ifAuthenticated,
        props: true,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.PROCESS_PAINEL,
              link: App.Breadcrumb.APP_PROCESS_PAINEL_LINK
            },
            { name: General.DETAILING }
          ]
        }
      },
      {
        path: "documento/:id",
        name: "Documento",
        component: DocumentDetails,
        beforeEnter: ifAuthenticated,
        props: route => ({
          id: route.params.id,
          processId: route.query.processId,
          isMain: route.query.main
        }),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            { name: General.DOCUMENT }
          ]
        }
      },
      {
        path: "documento-editor/:id",
        name: "Documento Editor",
        component: DocumentEditor,
        beforeEnter: haveProcessFileSign,
        props: route => ({
          id: route.params.id,
          template: String(route.query.template),
          dispatchId: route.query.dispatchId,
          fileId: route.query.fileId,
          isPrimary: String(route.query.isPrimary).toLowerCase() === "true",
          isEditable: String(route.query.isEditable).toLowerCase() === "true"
        }),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.PROCESS_PAINEL,
              link: App.Breadcrumb.APP_PROCESS_PAINEL_LINK
            },
            { name: General.DOCUMENT }
          ]
        }
      },
      {
        path: "admin/modelos",
        name: General.DOCUMENT_MODELS,
        component: Models,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_DOC_MODEL_ADM",
            "MANAGE_DOC_MODEL_PART",
            "MANAGE_DOC_MODEL_UNIT"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.DOCUMENT }
          ]
        }
      },
      {
        path: "admin/modelos-doe",
        name: General.OFFICIAL_MODELS,
        component: DOEModels,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_DOE_DOC_MODEL_ADM",
            "MANAGE_DOE_DOC_MODEL_PART",
            "MANAGE_DOE_DOC_MODEL_UNIT"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.DOCUMENT }
          ]
        }
      },
      {
        path: "admin/editor-modelos",
        name: "Novo Modelo",
        component: ModelEditor,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_DOC_MODEL_ADM",
            "MANAGE_DOC_MODEL_PART",
            "MANAGE_DOC_MODEL_UNIT"
          ])
      },
      {
        path: "admin/editor-modelos/:id",
        name: "Editar Modelo",
        component: ModelEditor,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_DOC_MODEL_ADM",
            "MANAGE_DOC_MODEL_PART",
            "MANAGE_DOC_MODEL_UNIT"
          ]),
        props: route => ({
          id: route.params.id
        })
      },
      {
        path: "admin/doe-editor",
        name: "Novo Modelo Oficial",
        component: DoeModelEditor,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_DOE_DOC_MODEL_ADM",
            "MANAGE_DOE_DOC_MODEL_PART",
            "MANAGE_DOE_DOC_MODEL_UNIT"
          ]),
        props: route => ({
          id: route.query.id
        })
      },
      {
        path: "doe-formulario",
        name: "Visualizar DOE",
        component: DoeModelView,
        beforeEnter: ifAuthenticated,
        props: route => ({
          modelId: route.query.modelId,
          processId: route.query.processId,
          fileId: route.query.fileId,
          dispatchId : route.query.dispatchId
        })
      },
      {
        path: "admin/enderecos-logos",
        name: App.AdminOverviewScreen.ADDRESS_LOGOS,
        component: PartGeneralInfo,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_ADDRESS_ADM",
            "MANAGE_ADDRESS_PART",
            "MANAGE_ADDRESS_CAPACITY"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.DOCUMENT }
          ]
        }
      },
      {
        path: "admin/cadastro-orgao",
        name: "Novo Cadastro",
        component: PartAddress,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "CREATE_PART_ADDRESS")
      },
      {
        path: "admin/cadastro-orgao/:id",
        name: "Editar Cadastro",
        props: route => ({
          id: route.params.id
        }),
        component: PartAddress,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "CREATE_PART_ADDRESS")
      },
      {
        path: "admin/assuntos-categorias",
        name: "Assuntos",
        component: SubjectsCategories,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "MANAGE_CATEGORY"),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.SUBJECT_PLURAL }
          ]
        }
      },
      {
        path: "admin/category",
        name: "Criar nova categoria",
        component: Category,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "MANAGE_CATEGORY")
      },
      {
        path: "admin/category/:id",
        name: "Categoria",
        props: route => ({
          id: route.params.id
        }),
        component: Category,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "MANAGE_CATEGORY")
      },
      {
        path: "admin/subcategoria/:id",
        props: route => ({
          id: route.params.id
        }),
        name: "Subcategoria 1",
        component: Subcategory,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "MANAGE_CATEGORY")
      },
      {
        path: "admin/subcategoria2/:id",
        props: route => ({
          id: route.params.id
        }),
        name: "Subcategoria 2",
        component: Subcategory2,
        beforeEnter: (to, from, next) =>
          ifAuthorized(to, from, next, "MANAGE_CATEGORY")
      },
      {
        path: "feedback",
        name: "Feedback",
        component: FeedbackPage
      },
      {
        path: "documentos-doe",
        name: App.MenuMain.DOCUMENTS_DOE,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, ["MANAGE_DOE", "AUTHORIZE_DOE"]),
        component: DOEPanel
      },
      {
        path: "admin/migracoes",
        name: "Migrações",
        beforeEnter: (to, from, next) =>
        haveSpecificPermissions(to, from, next, [
          "MIGRATE_PROCESS_ADM",
          "MIGRATE_PROCESS_SECTOR"
        ]),
        component: Migrations,
        meta: {
        breadcrumb: [
          { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
          {
            name: General.ADMINISTRATION,
            link: "/app/admin"
          },
          { name: App.MenuAdm.MIGRATION_PROCESS }
        ]
      }
      },
      {
        path: "admin/migracao-processos",
        name: App.MenuAdm.MIGRATION_PROCESS,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MIGRATE_PROCESS_ADM",
            "MIGRATE_PROCESS_SECTOR"
          ]),
        component: ProcessMigration,
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: App.MenuAdm.MIGRATION_PROCESS }
          ]
        }
      },
      {
        path: "admin/perfis",
        name: "Perfis",
        component: Profiles,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_PROFILES"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.PROFILES }
          ]
        }
      },
      {
        path: "admin/editor-perfil",
        name: "Novo Perfil",
        component: ProfileEditor,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_PROFILES"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.PROFILES }
          ]
        }
      },
      {
        path: "admin/editor-perfil/:id",
        name: "Editar Perfil",
        component: ProfileEditor,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_PROFILES"
          ]),
        props: route => ({
          id: route.params.id
        }),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: General.PROFILES }
          ]
        }
      },
      {
        path: "admin/relatorios",
        name: "Relatórios",
        component: Reports,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_REPORT_ADM",
            "MANAGE_REPORT_PART",
            "MANAGE_REPORT_UNIT"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: App.MenuAdm.REPORTS }
          ]
        }
      },
      {
        path: "admin/mensagens",
        name: "Mensagens",
        component: MessagesArea,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_MESSAGES_ADM"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: App.MenuAdm.MESSAGES_AREA }
          ]
        }
      },
      {
        path: "admin/enviar-mensagens",
        name: "Enviar Mensagens",
        component: SendMessage,
        beforeEnter: (to, from, next) =>
          haveSpecificPermissions(to, from, next, [
            "MANAGE_MESSAGES_ADM"
          ]),
        meta: {
          breadcrumb: [
            { name: App.Breadcrumb.START, link: App.Breadcrumb.APP_LINK },
            {
              name: General.ADMINISTRATION,
              link: "/app/admin"
            },
            { name: App.MenuAdm.SEND_MESSAGES }
          ]
        }
      }
    ],
  },
  {
    path: "/404",
    name: "Não encontrado",
    component: PageNotFound
  },
  {
    path: "*",
    redirect: to => {
      const oldPanelPath = /\/painel-processos/
      if (oldPanelPath.test(to.fullPath)) return to.fullPath.replace(oldPanelPath, "/processos")
      return '/404'
    }
    
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {});
};

export default router;
